import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import GoogleSheetsRegular from './google-sheets-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <GoogleSheetsRegular {...validProps} />;
}
SvgComponent.iconName = 'googleSheetsRegular';

export const GoogleSheetsRegularIcon = svgIconWrapper(SvgComponent);
